<template>
  <v-dialog v-model="model" width="600" persistent>
    <v-card style="border-radius: 10px">
      <v-card-title class="d-flex justify-space-between align-center">
        <span class="text-h6 font-weight-bold">Qualifications</span>
        <v-btn icon @click="closeModal">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>

      <v-card-text>
        <div class="text-subtitle-2  text-grey mb-4">
          Add your academic qualification details such as School,
          Undergrad and Post graduation degree.
        </div>

        <v-form ref="formRef" v-model="formValid">
        <v-select
          label="Degree *"
          :items="degrees"
          v-model="form.degree"
          density="comfortable"
          variant="outlined"
          class="mb-4"
           :rules="[v => !!v || 'Degree is required']"
        />

        <v-text-field
          label="Specialization"
          v-model="form.specialization"
          variant="outlined"
          density="comfortable"
          class="mb-4"
        />

        <v-text-field
          label="University Name *"
          v-model="form.university"
          variant="outlined"
          density="comfortable"
          class="mb-4"
          :rules="[v => !!v || 'University is required']"
        />

        <v-text-field
          label="Country"
         
          v-model="form.country"
          density="comfortable"
          variant="outlined"
          class="mb-4"
        />

        <div class="d-flex gap-4">
          <v-text-field
            label="Yr. of Graduation *"
            v-model="form.graduationStart"
            type="date"
            variant="outlined"
            density="comfortable"
            class="mb-4"
            :rules="[v => !!v || 'Start date is required']"
          />
          <v-text-field
            label="Yr. of Graduation *"
            v-model="form.graduationEnd"
            type="date"
            variant="outlined"
            density="comfortable"
            class="mb-4"
             :rules="[v => !!v || 'End date is required']"
          />
        </div>
         </v-form>
      </v-card-text>

      <v-card-actions class="d-flex justify-end">
        <v-btn variant="outlined" @click="clearAll">Clear All</v-btn>
        <v-btn variant="flat" color="primary" :disabled="!formValid"  @click="save">Save</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script setup>
import { ref, watch, defineProps, defineEmits, onMounted } from 'vue';
import { useStore } from 'vuex';


const store = useStore();

const props = defineProps({
  modelValue: Boolean
});
const emit = defineEmits(['update:modelValue']);

const model = ref(props.modelValue);

const formValid = ref(false);
const formRef = ref(null);
watch(() => props.modelValue, (val) => (model.value = val));
watch(model, (val) => emit('update:modelValue', val));

const form = ref({
  degree: '',
  specialization: '',
  university: '',
  country: '',
  graduationStart: '',
  graduationEnd: ''
});

const degrees = ['High School', 'Diploma', 'Bachelors', 'Masters', 'PhD'];
const countries = ['Kenya', 'Uganda', 'Tanzania', 'Rwanda', 'Other'];

const clearAll = () => {
  form.value = {
    degree: '',
    specialization: '',
    university: '',
    country: '',
    graduationStart: '',
    graduationEnd: ''
  };
 // formRef.value.resetValidation();
};

const closeModal = () => {
  model.value = false;
  clearAll();
};
const save = () => {
  // Manually trigger validation before saving
  formRef.value.validate().then((valid) => {
    if (!valid) {
      return;
    }

    // Dispatch to Vuex
    store.dispatch('profile/saveQualification', {
      degree: form.value.degree,
      specialization: form.value.specialization,
      university: form.value.university,
      country: form.value.country,
      graduationStart: form.value.graduationStart,
      graduationEnd: form.value.graduationEnd
    });

    // Console‐log the newly saved object for debugging:
    console.log(
      '🟢 [profile.qualification] =',
      store.state.profile.qualification
    );

    // Close the dialog
    model.value = false;

    store.dispatch("alert/success", "Qualification saved successfully");
  });
};


onMounted(() => {
  watch(
    () => model.value,
    (isOpen) => {
      if (isOpen) {
        // Pre‐fill the form if `profile.qualification` is non‐empty
        const q = store.state.profile.qualification || {};
        form.value = {
          degree: q.degree || '',
          specialization: q.specialization || '',
          university: q.university || '',
          country: q.country || '',
          graduationStart: q.graduationStart || '',
          graduationEnd: q.graduationEnd || ''
        };
       
      }
    }
  );
});
</script>

<style scoped>
.gap-4 {
  gap: 16px;
}
</style>
